import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import FileDownloadOutlinedIcon from 'components/material-symbol/icons/FileDownload'

const DownloadPlanButton = ({ label, onClick, className }) => (
  <Button
    variant="outlined"
    color="primary"
    size="large"
    className={className}
    startIcon={<FileDownloadOutlinedIcon />}
    onClick={onClick}
  >
    {label}
  </Button>
)

DownloadPlanButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default DownloadPlanButton
